<div class="ap-modal-footer">
  <div class="ap-modal-footer-customize">
    <div #footerContainer>
      <ng-content></ng-content>
    </div>
    @if (hasNotChildren) {
      @if (!hideSecondaryButton) {
        <ap-button
          btnType="secondary"
          [icon]="secondaryIconButton"
          [label]="secondaryButtonLabel"
          (onClick)="cancelHandler()"
          (keyup.enter)="cancelHandler()" />
      }
      @if (!hidePrimaryButton) {
        <ap-button
          btnType="primary"
          [icon]="primaryIconButton"
          [label]="primaryButtonLabel"
          (onClick)="confirmHandler()"
          (keyup.enter)="confirmHandler()"
          [disabled]="!isEnabled" />
      }
    }
  </div>
</div>
